<template>
  <div class="ivan-setting-page anCore-fill" v-loading="loading">
    <div class="row filters form-horizontal">
      <div class="pull-left" style="margin-left:5px;margin-right:5px;width:130px;">
        <input class="form-control" v-model="formKey" placeholder="分析表单..." @input="resetPage">
      </div>
      <div class="pull-left" style="margin-left:1px;margin-right:15px;width:290px;">
        <input class="form-control" v-model="itemKey" placeholder="项目名称，或参数序号..." @input="resetPage">
      </div>
      <div class="pull-left" style="margin-left:1px;margin-right:5px;width:130px;">
        <input class="form-control" v-model="methodKey" placeholder="方法依据关键字..." @input="resetPage">
      </div>
      <div class="pull-left" style="margin-left:10px;">
        <button type="button" class="btn btn-info btn-sm" @click="resetPage">
          <i class="fa fa-search" />&nbsp;查询
        </button>
      </div>
      <div style="clear:both;" />
    </div>

    <div class="table-area">
      <table class="table table-hover table-bordered table-condensed">
        <thead>
          <tr>
            <td style="min-width:68px;line-height:50px;">序号</td>
            <td style="min-width:68px;line-height:50px;">项目类型</td>
            <td style="min-width:68px;line-height:50px;">方法依据</td>
            <td style="min-width:68px;line-height:50px;">项目名称</td>
            <td style="width:50px;">有效位数</td>
            <td style="width:50px;">小数位数</td>
            <td style="width:100px;line-height:50px;">检出限(最低)</td>
            <td style="width:50px;">测定波长</td>
            <td style="min-width:68px;line-height:50px;">分析仪器</td>
            <td style="min-width:68px;line-height:50px;">分析表单</td>
            <td style="min-width:68px;line-height:50px;">分析人员</td>
            <td style="min-width:68px;line-height:50px;">审核人员</td>
            <td style="min-width:68px;line-height:50px;">备注</td>
            <td style="width:95px;text-align:center;">
              <button type="button" class="btn btn-success btn-sm" @click="onReadonly">
                <i class="fa fa-plus" />&nbsp;新增
              </button>
            </td>
          </tr>
        </thead>
        <tbody v-if="pageRows.length">
          <tr
            v-for="row in pageRows"
            :key="row.AnalyseItemParamsID"
            :class="{ 'anCore-item-active': selectedId === row.AnalyseItemParamsID }"
            @click="selectRow(row.AnalyseItemParamsID)"
          >
            <td>{{ row.SerialNo }}</td>
            <td>
              <div style="font-weight:bold;">{{ row.InspectBasicTypeName }}</div>
              <div class="text-muted" style="font-size:smaller;">{{ row.InspectSubTypeNames }}</div>
            </td>
            <td>
              <div>{{ row.MethodName }}</div>
              <div class="small text-muted"><span>{{ row.AccordName }}</span></div>
            </td>
            <td><label>{{ row.ItemName }}</label></td>
            <td>{{ empty(row.SignificantFigure) }}</td>
            <td>{{ empty(row.DecimalDigits) }}</td>
            <td>
              <span>{{ empty(row.LowLimit) }}</span>
              <span class="text-muted small">{{ row.Unit || '' }}</span>
            </td>
            <td>{{ empty(row.Wavelength) }}</td>
            <td>
              <div v-for="(ins, i) in (row.InstrumentList || [])" :key="i">
                <div>{{ ins.InsName }}</div>
                <div class="small text-muted">
                  <span>{{ ins.InsSize }}</span>
                  <span>{{ ins.InsNo }}</span>
                </div>
              </div>
            </td>
            <td>{{ row.FormName }}</td>
            <td>{{ row.AnalyseUserName }}</td>
            <td>{{ row.AuditUserName }}</td>
            <td>{{ row.Remark || '' }}</td>
            <td>
              <button type="button" class="btn btn-link btn-sm" title="编辑" @click.stop="onReadonly">
                <i class="fa fa-edit" />
              </button>
              <button type="button" class="btn btn-link btn-sm" title="删除" @click.stop="onReadonly">
                <i class="fa fa-trash-o text-muted" />
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="14">
              <div class="text-center text-muted" style="padding:10px 0;">当前暂无数据</div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pager-bar">
        <span class="text-muted">共 {{ filtered.length }} 条，</span>
        <ivan-pager :page-index.sync="pageIndex" :page-count="pageCount" @change="selectedId = null" />
      </div>
    </div>
  </div>
</template>

<script>
import { loadIvanSyncJson } from '@/utils/ivanSync'
import ivanSettingList from '@/mixins/ivanSettingList'
import IvanPager from '@/components/ivan/IvanPager.vue'

const PAGE_SIZE = 20

export default {
  name: 'AnalyseParamSetting',
  components: { IvanPager },
  mixins: [ivanSettingList],
  data() {
    return {
      loading: false,
      list: [],
      itemKey: '',
      formKey: '',
      methodKey: ''
    }
  },
  computed: {
    filtered() {
      const item = String(this.itemKey || '').trim().toLowerCase()
      const form = String(this.formKey || '').trim().toLowerCase()
      const method = String(this.methodKey || '').trim().toLowerCase()
      return this.list.filter(row => {
        if (item) {
          const hay = `${row.ItemName || ''} ${row.SerialNo || ''}`.toLowerCase()
          if (hay.indexOf(item) < 0) return false
        }
        if (form && String(row.FormName || '').toLowerCase().indexOf(form) < 0) return false
        if (method) {
          const hay = `${row.MethodName || ''} ${row.AccordName || ''}`.toLowerCase()
          if (hay.indexOf(method) < 0) return false
        }
        return true
      })
    },
    pageCount() {
      return this.calcPageCount(this.filtered.length, PAGE_SIZE)
    },
    pageRows() {
      return this.pageSlice(this.filtered, PAGE_SIZE)
    }
  },
  created() {
    this.load()
  },
  methods: {
    empty(v) {
      return v == null ? '' : v
    },
    async load() {
      this.loading = true
      try {
        const data = await loadIvanSyncJson('analyse_param.json')
        const grid = data && data.data
        this.list = (grid && grid.List) || []
      } catch (e) {
        this.$message.error(e.message || '加载分析参数失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.ivan-setting-page {
  height: 100%;
  min-width: 1100px;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.filters { margin: 8px 0; flex: 0 0 auto; }
.table-area {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}
.table-area >>> tbody tr { cursor: pointer; }
.pager-bar { overflow: hidden; padding: 6px 0; }
.pager-bar .text-muted { float: left; line-height: 28px; margin-right: 8px; }
.pager-bar .pagination { float: left; }
</style>
